export const vacationResponseStatus = Object.freeze({
  IS_COMING: 'is_coming',
  IS_NOT_COMING: 'is_not_coming',
  PENDING_ANSWER: 'pending_answer',
});
